import { Row } from '../../UIPackage/FormModule/components/Row';
import { TextInput } from '../../UIPackage/MainModule/components/TextInput';
import styles from '../PassportGroupFormModule/components/CommonGroupCondition.module.scss';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';
import { Checkbox } from '../../UIPackage/MainModule/components/Checkbox';
import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupCommonConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupCommonConditionsForm';
import { PassportGroupPassportTypeEnum } from '../PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';

interface IPassportGroupDetailCommonConditionsProps {
  condition: IGroupCommonConditionsForm | undefined;
  category: PassportGroupPassportTypeEnum | undefined;
}

export const PassportGroupDetailCommonConditions = ({
  condition,
  category,
}: IPassportGroupDetailCommonConditionsProps) => {
  const isDecision = category === PassportGroupPassportTypeEnum.DECISION_PASSPORT;

  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Общие сведения мероприятий">
      <>
        {!!condition.startDate && !!condition.endDate && (
          <Row title={isDecision ? 'Период дат вынесения решения' : 'Период проведения'} justify="start" align="center">
            <TextInput value={condition.startDate} disabled />
            <span className={styles.DateFieldsSpace}>—</span>
            <TextInput value={condition.endDate} disabled />
          </Row>
        )}
        {!!condition.domains?.length && (
          <>
            <FieldBlock label="Территориальная единица" margin="bottom">
              <SelectInput value={condition.domains} isMulti disabled />
            </FieldBlock>
            <Row>
              <Checkbox
                checked={condition.includeDomainChild}
                label="Включая подчиненные организации"
                theme="system"
                type="checkbox"
                disabled
              />
            </Row>
          </>
        )}
        {!!condition.knoOrganizations?.length && (
          <>
            <FieldBlock label="Контрольный (надзорный) орган" margin="bottom">
              <SelectInput value={condition.knoOrganizations} isMulti disabled />
            </FieldBlock>
            <Row>
              <Checkbox
                checked={condition.includeKnoOrganizationChild}
                label="Включая подчиненные организации"
                theme="system"
                type="checkbox"
                disabled
              />
            </Row>
          </>
        )}
        {!!condition.knoOrganizationLevels?.length && (
          <FieldBlock label="Уровень контрольного (надзорного) органа" margin="bottom">
            <SelectInput value={condition.knoOrganizationLevels} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.kindControls?.length && (
          <FieldBlock label="Вид контроля (надзора)" margin="bottom">
            <SelectInput value={condition.kindControls} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.knmTypes?.length && (
          <FieldBlock label="Характер мероприятия" margin="bottom">
            <SelectInput value={condition.knmTypes} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.plans?.length && (
          <FieldBlock label="Номер плана" margin="bottom">
            <SelectInput value={condition.plans} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.knmKinds?.length && (
          <FieldBlock label="Вид мероприятия" margin="bottom">
            <SelectInput value={condition.knmKinds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.pmKinds?.length && (
          <FieldBlock label="Вид мероприятия" margin="bottom">
            <SelectInput value={condition.pmKinds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.decisionKinds?.length && (
          <FieldBlock label="Вид мероприятия" margin="bottom">
            <SelectInput value={condition.decisionKinds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.reasons?.length && (
          <FieldBlock label="Основание проведения мероприятия" margin="bottom">
            <SelectInput value={condition.reasons} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.riskIndikators?.length && (
          <FieldBlock label="Индикаторы риска" margin="bottom">
            <SelectInput value={condition.riskIndikators} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.erpIds?.length && (
          <FieldBlock label="Учётный номер мероприятия" margin="bottom">
            <SelectInput value={condition.erpIds} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.unableToRefuse && (
          <FieldBlock label="Профилактический визит, от которого нельзя отказаться" margin="bottom">
            <SelectInput value={condition.unableToRefuse} disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
